import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Seller, status } from "../../types/sellerType";
import { api } from "../../config/Api";

const API_URL = '/admin/api';

export const fetchAllSellers = createAsyncThunk<Seller[],void>(
    'adminSeller/fetchAllSellers',
    async(_,{ rejectWithValue }) =>{
        try {
              const response = await api.get(`${API_URL}/sellers`);
            
              return response.data as Seller[];
            } catch (error: any) {
            
              if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); // Return error response data if available
              } else {
                return rejectWithValue('An error occurred while get all sellers.');
              }
            }
    }
)

export const updateSellers = createAsyncThunk<Seller,{id:number,status:status}>(
    'adminSeller/updateSellers',
    async({id,status},{ rejectWithValue }) =>{
        try {
              const response = await api.patch(`${API_URL}/seller/${id}/status/${status}`);
         
              return response.data as Seller;
            } catch (error: any) {
             
              if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); // Return error response data if available
              } else {
                return rejectWithValue('An error occurred while updating seller.');
              }
            }
    }
)


interface AdminSellerType{
    sellers:Seller[],
    loading:boolean,
    error:boolean,
}

const initialState:AdminSellerType= {
    sellers:[],
    loading:true,
    error:false
}


const AdminSellerSlice = createSlice({
    name:"adminSeller",
    initialState,
    reducers:{},
    extraReducers:(builder) => { 

        // getAllSellers
        builder.addCase(fetchAllSellers.pending,(state)=>{
            state.loading=true;
            state.error=false;
        })
        .addCase(fetchAllSellers.fulfilled,(state,action:PayloadAction<Seller[]>)=>{
            state.loading=false;
            state.sellers=action.payload
        })
        .addCase(fetchAllSellers.rejected,(state)=>{
            state.loading=false;
           state.error=true
        })

        // update seller
        .addCase(updateSellers.pending,(state)=>{
            state.loading=true;
            state.error=false;
        })
        .addCase(updateSellers.fulfilled,(state,action:PayloadAction<Seller>)=>{
            state.loading=false;
            const index = state.sellers ? state.sellers.findIndex((seller) => seller.id===action.payload.id) :-1
            if(index!==-1){
                state.sellers[index]= action.payload
            }
        })
        .addCase(updateSellers.rejected,(state)=>{
            state.loading=false;
           state.error=true
        })
     }
})

export const adminSellerSliceReducer = AdminSellerSlice.reducer